/*eslint-disable */
const $ = window.jQuery = require('jquery');

import { VueEditor } from "vue2-editor";
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'update-blog',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      categoryData: ['Acute Lymphoblastic Leukemia ',
        'Acute Myeloid Leukaemia',
        'Adenocarcinoma',
        'Allogenic Stem Cell Transplant',
        'Anatomy',
        'Artificial Intelligence in Medicine',
        'Autoimmune Diseases',
        'Autologous Stem Cell Transplant',
        'Biochemistry',
        'Biomedical Engineering',
        'Biotechnology',
        'Bone Cancer',
        'Breast Cancer',
        'CNS Tumor',
        'COVID/Sar-Cov',
        'Cancer Biology',
        'Cancer Care',
        'Cancer Research',
        'Cancer Treatment',
        'Carcinoid Tumors',
        'Cardiology',
        'Cell Biology',
        'Cervical Cancer',
        'Chemotherapy',
        'Chronic Myeloid Leukaemia',
        'Clinical Trials',
        'Colorectal Cancer',
        'Computational Pathology',
        'Computational Radiology',
        'Data Science',
        'Dermatology',
        'Diffuse Large B Cell Lymphoma',
        'Diseases',
        'Drug Discovery',
        'Drugs',
        'ENT',
        'Esophageal Cancer',
        'Gastric Cancer',
        'Gastroenterology',
        'Gastrointestinal Stromal Tumor',
        'Glioblastoma',
        'Gynaecology',
        'HIV',
        'HPV',
        'Head and Neck Cancer',
        'Hematology',
        'Hepatitis',
        'Hepatocellular Carcinoma',
        'Hodgkin’s Lymphoma',
        'Hospital Management',
        'Immunology',
        'Immunotherapy',
        'Liver Cancer',
        'Lung Cancer',
        'Mathematical Oncology',
        'Medical Big Data',
        'Medical Machine Learning',
        'Medical Oncology',
        'Medical Physics',
        'Medulloblastoma',
        'Melanoma',
        'Multiple Myeloma',
        'Neurology',
        'Neuroscience',
        'Non-Hodgkin’s Lymphoma',
        'Nuclear Medicine',
        'Oncology',
        'Orthopaedics',
        'Other Healthcare Issue',
        'Ovarian Cancer',
        'Paediatric Oncology',
        'Paediatrics',
        'Palliative Cancer Therapy',
        'Pancreatic Cancer',
        'Pancreatic Neuroendocrine Tumor',
        'Pathology',
        'Pharmaceutical Sciences',
        'Pharmacology',
        'Physiology',
        'Primitive Neuroectodermal Tumor',
        'Prostrate Cancer',
        'Psychiatry',
        'Psychology',
        'Pulmonary Medicine',
        'Radiation Oncology',
        'Radiology',
        'Radiotherapy',
        'Renal Cell Carcinoma',
        'Retinoblastoma',
        'Sarcoma',
        'Signet Ring Cell Carcinoma',
        'Small Cell Carcinoma',
        'Stem Cell Science',
        'Surgery',
        'Surgical Oncology',
        'Testicular Cancer',
        'Therapeutics',
        'Throat Cancer',
        'Toxicology',
        'Urology',
        'Uterine Cancer',
        'Vaccine',
        'Virology'
      ],
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
      singleBlogDetails:null,
      is_publish: false,
      submitted: false,
      title: '',
      category: '',
      content: '',
      file: null,
      uploadAttachmentName: '',
      selfUserId: '',
      uploadImgSize: false,
      selectedFile:null,
      dataFileCode:'',
      blogLoader:true
    }
  },
  computed: {
    ...mapGetters([
      'blogDetailsByIdGetters'
    ]),
    getBlogDetailsAgainFun() {
      this.singleBlogDetails = this.$store.getters.blogDetailsByIdGetters.response;
      return;
    },
    setIntialSates() {
      if (this.singleBlogDetails){
        this.title = this.singleBlogDetails.title
        this.content = this.singleBlogDetails.data
        this.category = this.singleBlogDetails.category
        this.is_publish = this.singleBlogDetails.is_public
        this.selfUserId = this.singleBlogDetails.user.id
        this.selectedFile = this.singleBlogDetails.file
        if (this.singleBlogDetails.file){
          var Filename = this.singleBlogDetails.file.split("/")[5].split('?')[0]
          this.uploadAttachmentName = Filename
        }
        if(this.singleBlogDetails.data_file){
          this.getDataFromDataFileMethod(this.singleBlogDetails.data_file)
        }
      }
    }
  },
  mounted() {
    this.getBlogDetailsAgainFun
    this.setIntialSates
  },
  methods: {
    getDataFromDataFileMethod(fileUrl) {
      var __self = this
      fetch(fileUrl)
        .then(function (response) {
          switch (response.status) {
            // status "OK"
            case 200:
              return response.text();
            // status "Not Found"
            case 404:
              throw response;
          }
        })
        .then(function (template) {
          __self.dataFileCode = template
          __self.blogLoader = false
        })
        .catch(function (response) {
        });
    },
    selectedCategoryFun(val) {
      this.category = val
    },
    blogPublishedToggle() {
      if (this.is_publish === false) {
        this.is_publish = true
      } else {
        this.is_publish = false
      }
    },
    // GET THE IMAGE WIDTH AND HEIGHT USING fileReader() API.
    readImageFile(file) {
      var __self = this
      var reader = new FileReader(); // CREATE AN NEW INSTANCE.
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          var w = this.width;
          var h = this.height;
          if (w > 1200 && h > 150) {
            __self.uploadImgSize = true
          } else {
            __self.uploadImgSize = false
          }
        }
      };
      reader.readAsDataURL(file);
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.readImageFile(event.target.files[0])
        setTimeout(() => {
          if (this.uploadImgSize) {
            this.file = event.target.files[0];
            this.files = this.$refs.file.files[0];
            this.uploadAttachmentName = this.files.name
          } else {
            alert("The Height And Width Must Be Greater Than 1200px * 150px")
          }
        },100)
      }else{
        this.uploadAttachmentName = '';
      }
    },
    cancelUploadingFileFun() {
      this.file = null
      this.files = null
      this.uploadAttachmentName = '';
      this.uploadImgSize = false
      this.selectedFile = null
    },
    updateBlogBeforeSubmitMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          var formData = new FormData();
          formData.append('user', this.selfUserId);
          formData.append('title', this.title);
          formData.append('data', this.dataFileCode);
          formData.append('category', this.category);
          formData.append('is_public', this.is_publish);
          if (this.file != null) {
            formData.append('file', this.file);
          }
          this.$store.dispatch('updateBlogDetailsAction', { data: { data: formData, id: this.$route.params.updateId } }).then((res) => {
            this.submitted = false
            toast.success(res.data.msg);
            this.$router.push({ name: 'DashboardMain'})
          }).catch((err) => {
            this.submitted = false
            toast.error(err.data.msg);
          })

        }
      })

    }
  },
  watch: {
    getBlogDetailsAgainFun() {
      return this.$store.getters.blogDetailsByIdGetters;
    },
    setIntialSates() {
      if (this.singleBlogDetails) {
        this.title = this.singleBlogDetails.title
        this.content = this.singleBlogDetails.data
        this.category = this.singleBlogDetails.category
        this.is_publish = this.singleBlogDetails.is_public
        this.selfUserId = this.singleBlogDetails.user.id
        if (this.singleBlogDetails.file) {
          var Filename = this.singleBlogDetails.file.split("/")[5].split('?')[0]
          this.uploadAttachmentName = Filename
        }
        if(this.singleBlogDetails.data_file){
          this.getDataFromDataFileMethod(this.singleBlogDetails.data_file)
        }
      }
    }
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}